var _defs, _g, _g2, _rect, _g3, _g4, _circle, _path, _path2, _path3, _g5, _g6, _g7, _path4, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFishiesafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 988.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .fishies_after_svg__cls-3{fill:#343a50}.fishies_after_svg__cls-10,.fishies_after_svg__cls-17,.fishies_after_svg__cls-18,.fishies_after_svg__cls-21,.fishies_after_svg__cls-23,.fishies_after_svg__cls-26,.fishies_after_svg__cls-29,.fishies_after_svg__cls-31,.fishies_after_svg__cls-32,.fishies_after_svg__cls-8{stroke:#343a50}.fishies_after_svg__cls-17,.fishies_after_svg__cls-18,.fishies_after_svg__cls-20,.fishies_after_svg__cls-21,.fishies_after_svg__cls-23,.fishies_after_svg__cls-26,.fishies_after_svg__cls-29,.fishies_after_svg__cls-30,.fishies_after_svg__cls-31,.fishies_after_svg__cls-32,.fishies_after_svg__cls-8{stroke-miterlimit:10}.fishies_after_svg__cls-6{fill:#eb9a6b}.fishies_after_svg__cls-8{fill:#7fc3ca}.fishies_after_svg__cls-10,.fishies_after_svg__cls-17,.fishies_after_svg__cls-18,.fishies_after_svg__cls-21,.fishies_after_svg__cls-8{stroke-width:2px}.fishies_after_svg__cls-9{fill:#d88b64}.fishies_after_svg__cls-10,.fishies_after_svg__cls-16{fill:#dedede}.fishies_after_svg__cls-10{stroke-linecap:round;stroke-linejoin:round}.fishies_after_svg__cls-11,.fishies_after_svg__cls-35{fill:#fff}.fishies_after_svg__cls-11{opacity:.32}.fishies_after_svg__cls-17,.fishies_after_svg__cls-31{fill:#191919}.fishies_after_svg__cls-18,.fishies_after_svg__cls-29{fill:#857d7a}.fishies_after_svg__cls-23,.fishies_after_svg__cls-26{stroke-width:3px}.fishies_after_svg__cls-20,.fishies_after_svg__cls-30{fill:none;stroke:#191919}.fishies_after_svg__cls-20{stroke-width:4.8px}.fishies_after_svg__cls-21,.fishies_after_svg__cls-32{fill:#f84c34}.fishies_after_svg__cls-23{fill:#f9cab8}.fishies_after_svg__cls-26{fill:#464655}.fishies_after_svg__cls-29,.fishies_after_svg__cls-32{stroke-width:.69px}.fishies_after_svg__cls-30{stroke-width:1.37px}.fishies_after_svg__cls-31{stroke-width:.32px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Fish_n_Tipps_Nachher",
    "data-name": "Fish'n'Tipps_Nachher"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9bf5c",
    points: "-1 989.09 -1 581.01 1259 568.67 1259 989.09 -1 989.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 569.68v418.41H0V582l1258-12.32m2-2h-2L0 580h-2v410.09h1262V567.66z",
    className: "fishies_after_svg__cls-3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Weg"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "767.82 989.09 969.75 583.15 -1 583 -1 522.01 1258.98 524.51 1259.99 581.71 1259 989.09 767.82 989.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 523l1258 2.5 1 56.21-1 406.36H769.44l201.92-405.92L0 582v-59m-2-2v63h2l968.13.15-200.48 403-1.44 2.89H1260v-2l1-406.36-1-56.26v-2h-2L0 521z",
    className: "fishies_after_svg__cls-3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "fishies_after_svg__Himmel",
    width: 1259.75,
    height: 616.63,
    y: -93.62,
    fill: "#a5d1d6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Haus"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.87 524.5 1.01 90.79 1259.06 90.79 1259.06 524.5 2.87 524.5",
    className: "fishies_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.06 91.79V523.5H3.87L2 91.79h1256.06m2-2H0l1.87 435.72h1258.19V89.79z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 359.33,
    height: 429.91,
    x: 4.48,
    y: 92.1,
    fill: "#bc7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.81 93.1V521H5.48V93.1h357.33m2-2H3.48V523h361.33V91.1z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 199.74,
    height: 325.05,
    x: 40.19,
    y: 124.76,
    className: "fishies_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.67,
    height: 323.05,
    x: 129.23,
    y: 125.76,
    className: "fishies_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 126.76v321.05h-19.67v-321h19.67m2-2h-23.67v325h23.67v-325z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 197.91,
    height: 21.67,
    x: 41.19,
    y: 276.45,
    className: "fishies_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1 277.45v19.67H42.19v-19.67H238.1m2-2H40.19v23.67H240.1v-23.67z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 199.74,
    height: 325.05,
    x: 848.12,
    y: 124.76,
    className: "fishies_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "937.16 449.8 937.16 298.12 847.61 298.12 847.61 276.45 937.16 276.45 937.16 124.74 958.83 124.74 958.83 276.45 1047.85 276.45 1047.85 298.12 958.83 298.12 958.83 449.8 937.16 449.8",
    className: "fishies_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.83 125.74v151.71h89v19.67h-89V448.8h-19.67V297.12h-89.55v-19.67h89.55V125.74h19.67m2-2h-23.67v151.71h-89.55v23.67h89.55V450.8h23.67V299.12h89v-23.67h-89V123.74z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180.69,
    height: 325.05,
    x: 1078.33,
    y: 124.76,
    className: "fishies_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1167.37 449.8 1167.37 298.12 1078.34 298.27 1078.3 276.61 1167.37 276.45 1167.37 124.75 1189.03 124.75 1189.03 276.41 1258.98 276.29 1259.02 297.96 1189.03 298.08 1189.03 449.8 1167.37 449.8",
    className: "fishies_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188 125.75v151.67h2l67.94-.12v19.67l-68 .12h-2V448.8h-19.66V297.12h-2l-87 .15V277.6l87.07-.15h2v-151.7H1188m2-2h-23.66v151.7l-89.07.16v23.66l89-.15V450.8H1190V299.08l70-.12v-23.67l-70 .12V123.75z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 325.95,
    height: 377.38,
    x: 473.9,
    y: 147.12,
    className: "fishies_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.85 148.12v375.39h-324V148.12h324m2-2h-328v379.39h328V146.12z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260.47,
    height: 354.49,
    x: 504.42,
    y: 170.01,
    className: "fishies_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.89 171v352.5H505.42V171h258.47m2-2H503.42v356.5h262.47V169z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.15 524.16 554.6 524.49 554.6 191.31 719.15 191.31 719.15 524.16",
    className: "fishies_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.43 524.51 631.43 438.27 554.13 438.27 554.13 427.38 631.43 427.38 631.43 350.44 554.13 350.44 554.13 339.55 631.43 339.55 631.43 265 554.13 265 554.13 254.11 631.43 254.11 631.43 191.3 642.32 191.3 642.32 254.11 719.38 254.11 719.38 265 642.32 265 642.32 339.55 719.06 339.62 719.06 350.5 642.32 350.44 642.32 427.38 719.13 427.38 719.14 438.27 642.32 438.27 642.32 524.51 631.43 524.51",
    className: "fishies_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.32 192.3v62.81h77.06V264h-77.06v76.55h2l74.74.07v8.88l-74.74-.06h-2v78.94h76.81v8.89h-76.81v86.24h-8.89v-86.24h-77.3v-8.89h77.3v-78.94h-77.3v-8.89h77.3V264h-77.3v-8.89h77.3V192.3h8.89m2-2h-12.89v62.81h-77.3V266h77.3v72.55h-77.3v12.89h77.3v74.94h-77.3v12.89h77.3v86.24h12.89v-86.24h76.83v-12.89h-76.83v-74.94l76.74.07v-12.89l-76.74-.07V266h77.06v-12.89h-77.06V190.3z",
    className: "fishies_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.9,
    x2: 503.42,
    y1: 146.12,
    y2: 169.01,
    className: "fishies_after_svg__cls-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 798.89,
    x2: 763.66,
    y1: 148.14,
    y2: 170.43,
    className: "fishies_after_svg__cls-10"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.26 6.24c5.5-12.91 19.39-22.13 35.8-22.13 16.21 0 30 9 35.63 21.65a29.72 29.72 0 017.26-1c14.8 0 26.8 10.7 26.8 23.9s-12 23.9-26.8 23.9H90.26c-14.81 0-26.81-10.7-26.81-23.9 0-10.37 7.46-19.11 17.81-22.42zM969.6-36.2c9.23-21.68 32.57-37.17 60.13-37.17 27.22 0 50.39 15.09 59.84 36.37a49.19 49.19 0 0112.19-1.68c24.86 0 45 18 45 40.14s-20.16 40.13-45 40.13h-117c-24.87 0-45-18-45-40.13-.07-17.46 12.45-32.1 29.84-37.66zM500.9-8.48c-6-14-21.09-24.06-38.93-24.06-17.62 0-32.63 9.77-38.75 23.54a32.29 32.29 0 00-7.88-1.08c-16.1 0-29.15 11.63-29.15 26s13.05 26 29.15 26h75.78c16.1 0 29.14-11.64 29.14-26 0-11.29-8.1-20.8-19.36-24.4zM715.46 19.51c5.18-12.18 18.3-20.89 33.79-20.89 15.3 0 28.32 8.48 33.63 20.44a27.89 27.89 0 016.85-.94c14 0 25.29 10.1 25.29 22.55s-11.32 22.56-25.29 22.56H724c-14 0-25.3-10.1-25.3-22.56-.05-9.79 6.99-18.04 16.76-21.16z",
    className: "fishies_after_svg__cls-11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Baum"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 781.28,
    cy: 66.78,
    r: 197.52,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M611.15 70.55C611.15-38.53 699.59-127 808.68-127c4.52 0 9 .17 13.44.47a197.71 197.71 0 00-40.84-4.24c-109.09 0-197.53 88.43-197.53 197.52 0 104.57 81.27 190.15 184.09 197.06C678.35 245 611.15 165.64 611.15 70.55z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M754.94 636.77a8.87 8.87 0 01-6.43-2.73 8.16 8.16 0 01-2.28-6.11l16.92-243.28-50.6-59.77a3.22 3.22 0 01-.51-3.52 3.44 3.44 0 013.09-2 3.5 3.5 0 011.87.57l48.46 31.48 12.32-177.23-36-35.65a2.12 2.12 0 01-.49-2.33 2.18 2.18 0 012-1.37 2.22 2.22 0 011 .23l35.12 16.77 4.8-69 .28-5.4a8.34 8.34 0 0116.63-.3l3.26 43.83 34.76-18.16h.15a5.1 5.1 0 01.86-.08 4.56 4.56 0 014.36 3.18 4.45 4.45 0 01-1.61 5.08l-35.6 25.38 31.71 491.37a8.18 8.18 0 01-2.15 6.27 8.88 8.88 0 01-6.55 2.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M792.76 70.55a7 7 0 017.29 6.61l3.38 45.33 36-18.79a4.2 4.2 0 01.69-.06 3.59 3.59 0 012.15 6.46l-36 25.68 31.74 491.93a7.55 7.55 0 01-7.7 8.06h-75.3a7.56 7.56 0 01-7.71-7.78l16.94-243.67-50.86-60.08a2.37 2.37 0 013.14-3.48l49.89 32.4 12.47-179.38-36.37-36a1.17 1.17 0 01.82-2 1.14 1.14 0 01.52.13l36.45 17.41 4.9-70.52.29-5.42a7.06 7.06 0 017.34-6.87m0-2a9.1 9.1 0 00-9.34 8.77l-.28 5.41-4.7 67.56-33.79-16.15a3.28 3.28 0 00-1.39-.32 3.15 3.15 0 00-2.93 2 3.08 3.08 0 00.71 3.42l35.71 35.33-12.24 175.11-47-30.56a4.37 4.37 0 00-6.41 1.86 4.23 4.23 0 00.65 4.59l50.3 59.47-16.89 242.85a9.2 9.2 0 002.56 6.88 9.89 9.89 0 007.15 3h75.3a9.87 9.87 0 007.28-3.17 9.15 9.15 0 002.41-7l-31.66-490.79 35.12-25a5.5 5.5 0 002-6.23 5.6 5.6 0 00-5.3-3.86 6 6 0 00-1 .09l-.31.06-.27.14-33.28 17.38L802.05 77a9.06 9.06 0 00-9.29-8.46z",
    className: "fishies_after_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M803.7 127l39.54-21a3.52 3.52 0 00-3.85-1.9l-36 19zM787.46 157.93L792.58 83l.28-5.49a7 7 0 013.62-6c-4.24-2.33-10.74-.28-11.06 6l-.29 5.49-4.88 71.44zM754.67 626l31.58-452.36-34.3-34-8.17-3.9a1.17 1.17 0 00-1.34 1.87l36.37 36-13.53 194.76L747.23 628a7.56 7.56 0 007.71 7.79h7.45c-4.39-.02-7.93-5.54-7.72-9.79z",
    className: "fishies_after_svg__cls-16"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Fahrrad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.27,
    height: 8.03,
    x: 895.02,
    y: 546.59,
    className: "fishies_after_svg__cls-17",
    rx: 3.32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "883.47 588.04 878.94 584.05 904.43 550.62 910.53 550.56 883.47 588.04",
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "752.21 589 700.84 538.78 706.38 533.66 757.75 583.88 752.21 589"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 879.69,
    cy: 591.01,
    r: 23.08,
    className: "fishies_after_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.67 584.54c1.62 6.64-.74 29.92-21.79 29.55-10.58-.19-134.82-8.68-130.75-29.55 2.87-14.77 87-16.62 130.75-16.62 0 0 17.73 0 21.79 16.62z",
    className: "fishies_after_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 660.69a76.51 76.51 0 1176.5-76.51 76.59 76.59 0 01-76.5 76.51zM757 515a69.21 69.21 0 1069.2 69.2A69.28 69.28 0 00757 515z",
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1032.63 583.25 1002.32 518.13 1009.31 515.29 1039.62 580.41 1032.63 583.25",
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.88 667.38A83.2 83.2 0 11815.72 643a82.67 82.67 0 01-58.84 24.38zm0-159.19a76 76 0 1076 76 76.06 76.06 0 00-76-76zM1036.85 667.38a83.2 83.2 0 1158.84-24.38 82.67 82.67 0 01-58.84 24.38zm0-159.19a76 76 0 1076 76 76.06 76.06 0 00-76-76z",
    className: "fishies_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065 495.68a91.28 91.28 0 00-65.88 3.88l-6.26-15.39a3.59 3.59 0 00-.84-3.54 3.53 3.53 0 00-.87-.68l-3.82-9.39a3.62 3.62 0 00-.1-2.45l-12.93-31.39a3.61 3.61 0 10-6.68 2.75l11 26.6L848 470.94l-8-28.56a3.61 3.61 0 00-7 2l8.37 29.52-28.85 36.54A90.94 90.94 0 00692 518.17a91.77 91.77 0 00-26.77 65.08 4.53 4.53 0 009 0c0-45.78 37-83 82.36-83a81.59 81.59 0 0150.29 17.31l-53 67.17a3.61 3.61 0 002.66 5.84L874 596.46h.18a2.23 2.23 0 00.37 0h.49l.25-.07h.11l.25-.1h.1l.25-.29.08-.05.27-.18a3.11 3.11 0 00.28-.23l112-106.68 5.4 13.28a92.28 92.28 0 00-48.46 81.31 4.52 4.52 0 009 0c0-45.77 37-83 82.37-83a81.65 81.65 0 0125.16 4 4.52 4.52 0 002.78-8.61zm-252.61 26.55a83.11 83.11 0 0126.58 61 4.51 4.51 0 003.47 4.39l-78.57-3.95zm31.71 65.49a4.51 4.51 0 003.92-4.47 91.77 91.77 0 00-26.77-65.08q-1.57-1.59-3.22-3.09l25.56-32.37L869.5 589zm32.08-1.79L849.9 478.1l132.43-4.94 3.42 8.42z",
    className: "fishies_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840.02,
    x2: 845.21,
    y1: 587.52,
    y2: 587.78,
    className: "fishies_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036.85,
    cy: 584.17,
    r: 7.2,
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.5 659.85a76.51 76.51 0 1176.5-76.51 76.59 76.59 0 01-76.5 76.51zm0-145.71a69.21 69.21 0 1069.2 69.2 69.28 69.28 0 00-69.2-69.2z",
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.61 442.8a7.56 7.56 0 01-4-3.75c-1.26-2.79-.65-6-.14-8.63.41-2.15 1.62-8.47 6.15-12.39 2.55-2.2 4.94-2.59 7.44-3a19.25 19.25 0 0112.88 2.07c5.23 2.94 5.73 6.46 11.27 8.34a20.58 20.58 0 005.47.85c7.12.58 11.17-1.09 19.18-.38 4.49.41 5.85 1.17 6.58 2.63 1.27 2.53.33 6.55-1 9-2.47 4.56-7.11 5.25-12 5.81-8.31 1-12.54.85-24.48 1.56-3.62.21-4 .31-7.86.51-6.9.35-13.24.43-19.49-2.62z",
    className: "fishies_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.48 376.68c.46-.46-1.87 2.85-2.75 6l-14.45 49.78-38.54 29.71c-2.63 1.88-5.1 2.19-3.22 4.81 1.15 1.6 1.08 1.57 2.9 1.57a5.84 5.84 0 003.41-1.1l37.61-27 5.1 12 7.48-3.19-7.13-16.74 13.65-48.59c.87-3.14-6.37-4.93-4.06-7.25z",
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 879.69,
    cy: 591.37,
    r: 7.2,
    className: "fishies_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.99,
    height: 5.91,
    x: 851.7,
    y: 605.96,
    className: "fishies_after_svg__cls-18",
    transform: "rotate(-64.16 871.267 608.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.03,
    height: 10.71,
    x: 848.85,
    y: 622.59,
    className: "fishies_after_svg__cls-17",
    rx: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 976.28,
    x2: 983.17,
    y1: 399.13,
    y2: 377.04,
    className: "fishies_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.42 402.32l-8.91-4.09 3.73-17.59c.77-3.62 3.38-5.63 5.84-4.51 2.46 1.13 3.83 5 3.07 8.6z",
    className: "fishies_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 938.96,
    x2: 926.74,
    y1: 454.18,
    y2: 465.35,
    className: "fishies_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.33 451l3.74 8.6-13.6 9.4c-2.8 1.91-5.91 1.54-6.94-.83-1-2.38.4-5.85 3.2-7.77z",
    className: "fishies_after_svg__cls-21"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Arm_Hand",
    "data-name": "Arm&Hand"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9cab8",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "569.34 1093.25 716.25 856.22 646.41 824.44 498.51 1051.2 569.34 1093.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 855.84c-19 38.76-47.66 67.52-76.63 80.66-20.78 9.42-41.74 10.81-59.48 2.1-42.47-20.87-50.39-91.75-17.68-158.31s93.64-103.62 136.11-82.76 50.33 91.74 17.68 158.31z",
    className: "fishies_after_svg__cls-23"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Handy"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.12,
    height: 292.24,
    x: 565.21,
    y: 646.42,
    fill: "#707484",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 26.92,
    transform: "rotate(26.16 649.826 792.657)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136.26,
    height: 235.47,
    x: 585.69,
    y: 666.57,
    fill: "#62aedb",
    rx: 21.69,
    transform: "rotate(26.16 653.88 784.434)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.16,
    cy: 905.23,
    r: 9.87,
    className: "fishies_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.8,
    height: 7.31,
    x: 702.64,
    y: 669.75,
    className: "fishies_after_svg__cls-26",
    rx: 3.66,
    transform: "rotate(26.16 717.614 673.523)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.78,
    cy: 663.21,
    r: 3.73,
    className: "fishies_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136.17,
    height: 92.61,
    x: 567.9,
    y: 774.14,
    fill: "#468abd",
    transform: "rotate(26.16 636.037 820.584)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.24,
    d: "M637 830.76l-4.29-2.08a1 1 0 01-.44-1.27l.18-.35a1 1 0 011.28-.43l4.29 2.08a.94.94 0 01.43 1.26l-.17.36a1 1 0 01-1.28.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.64 835.34 623.98 833.75 634.79 828.42 636.37 829.17 624.64 835.34",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.65 819.13 583.76 799.88 585.84 799.26 592.73 818.52 590.65 819.13",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 623.29,
    cy: 835.62,
    className: "fishies_after_svg__cls-30",
    rx: 6.64,
    ry: 6.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.78 836.73c-.43 1.89-4 7.54-9.37 4.8-2.71-1.37-33.68-19.11-30-23.92 2.62-3.41 24.55 6.66 35.84 12.14.01 0 4.58 2.25 3.53 6.98z",
    className: "fishies_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.79 838a21.67 21.67 0 01-10-29.11 22.13 22.13 0 0129.39-9.89 21.68 21.68 0 0110.05 29.12 22.15 22.15 0 01-29.44 9.88zm18.47-37.18a20 20 0 00-26.63 9 19.6 19.6 0 009.09 26.33 20 20 0 0026.62-9 19.59 19.59 0 00-9.08-26.31z",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.73 852.81 664.16 832.4 666.32 832.55 665.89 852.97 663.73 852.81",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.92 839.71a23.6 23.6 0 01-12.09-13.59 23.31 23.31 0 011.17-18.07 23.68 23.68 0 0113.75-11.95 24 24 0 0118.25 1.15 23.65 23.65 0 0112.09 13.6 23.29 23.29 0 01-1.17 18.06 23.7 23.7 0 01-13.75 12 24 24 0 01-18.25-1.2zm20.18-40.61a22 22 0 00-29.23 9.9 21.51 21.51 0 0010 28.91 22 22 0 0029.2-9.91 21.51 21.51 0 00-9.97-28.9zM654.15 874.81a23.65 23.65 0 01-12.09-13.6 23.29 23.29 0 011.17-18.06 23.7 23.7 0 0113.75-12 24 24 0 0118.26 1.16 23.53 23.53 0 0112.09 13.59 23.27 23.27 0 01-1.16 18.1 23.68 23.68 0 01-13.75 12 24 24 0 01-18.27-1.19zm20.18-40.62a22 22 0 00-29.23 9.86 21.53 21.53 0 0010 28.92 22 22 0 0029.23-9.87 21.51 21.51 0 00-10-28.91z",
    className: "fishies_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.17 834.52a26.43 26.43 0 00-17.49-7.27l.33-4.71a1 1 0 00.24-1 1.47 1.47 0 00-.14-.28l.2-2.87a1 1 0 00.29-.64l.64-9.63a1 1 0 00-2.07-.14l-.55 8.16L630.34 801l1.53-8.3a1 1 0 00-2-.37l-1.58 8.58-12.08 5.71a25.81 25.81 0 00-12-11.92 26.51 26.51 0 00-35.25 12 1.28 1.28 0 00.6 1.72 1.31 1.31 0 001.74-.58A23.92 23.92 0 01603 797a23.33 23.33 0 0110.78 10.72l-22.2 10.49a1 1 0 00-.59.9 1 1 0 00.54.92l29.55 16.23h.74l42.42-13.17-.29 4.06a26.69 26.69 0 00-7.65 1.42 26.3 26.3 0 00-15.16 13.25 1.28 1.28 0 00.6 1.72 1.31 1.31 0 001.74-.58 23.81 23.81 0 0137.76-6.7 1.32 1.32 0 001.84 0 1.29 1.29 0 00.09-1.74zm-68.53-24.88a23.4 23.4 0 01-.87 18.9 1.27 1.27 0 00.33 1.55l-19.77-10.85zm-.12 20.68a1.3 1.3 0 001.58-.65 25.85 25.85 0 001.34-20c-.13-.4-.28-.8-.44-1.19l10.7-5.06-6.79 30.37zm8.5 3.57l6.89-30.81 34.79 15.34-.18 2.57z",
    className: "fishies_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.7,
    cy: 853.58,
    className: "fishies_after_svg__cls-29",
    rx: 2.07,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.27 873a21.67 21.67 0 01-10-29.11 22.13 22.13 0 0129.44-9.93 21.66 21.66 0 0110 29.11 22.14 22.14 0 01-29.44 9.93zm18.47-37.18a20 20 0 00-26.62 9 19.59 19.59 0 009.08 26.33 20 20 0 0026.62-9 19.58 19.58 0 00-9.08-26.36z",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 630.32,
    cy: 788.97,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.69,
    rx: 2.95,
    ry: 11.07,
    transform: "rotate(-64.12 630.387 788.988)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677 793.82a11.44 11.44 0 00-1.5 1.18l-10 10.89-13.71 2.75c-.92.15-1.6-.08-1.44.82.09.55.08.54.55.76a1.68 1.68 0 001 .15l13.1-2.17-.21 3.7 2.34.13.28-5.17 9.68-10.69c.63-.68-1-2.06-.09-2.35z",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 623.24,
    cy: 835.72,
    className: "fishies_after_svg__cls-29",
    rx: 2.07,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "614.93 843.2 613.89 841.88 622.72 835.05 623.76 836.38 614.93 843.2",
    className: "fishies_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.83 845.88l-5.72-2.78a1.26 1.26 0 01-.58-1.69l.24-.47a1.27 1.27 0 011.7-.57l5.72 2.78a1.25 1.25 0 01.58 1.68l-.23.47a1.29 1.29 0 01-1.71.58z",
    className: "fishies_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.52,
    x2: 677.1,
    y1: 798.77,
    y2: 794,
    className: "fishies_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674 800.48l-1.78-2.16 3.19-4c.66-.83 1.59-1 2.08-.42a2.21 2.21 0 01-.3 2.58z",
    className: "fishies_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 655.92,
    x2: 651.35,
    y1: 808.14,
    y2: 809.46,
    className: "fishies_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.16 807.26l-.13 2.66-4.69.67c-1 .14-1.72-.34-1.68-1.08a2 2 0 011.8-1.58z",
    className: "fishies_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 683.03,
    cy: 725.63,
    r: 48.95,
    fill: "#1e1e1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__FishiesV2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698 676.77a22.79 22.79 0 1010.4 30.51 22.8 22.8 0 00-10.4-30.51zm1.22 32a9.22 9.22 0 01-10.12 5l-.27 5.58-4.36-2.15.25-5.21-6.42-3.15-4 3.38L670 710l4.25-3.63a9.22 9.22 0 01-2.26-11l6.84-13.92a9.24 9.24 0 0112.37-4.22l10.67 5.24a9.25 9.25 0 014.23 12.38z",
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.67,
    height: 8.67,
    x: 680.86,
    y: 681.87,
    className: "fishies_after_svg__cls-35",
    rx: 3.44,
    transform: "rotate(26.16 685.272 686.322)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.67,
    height: 8.67,
    x: 694,
    y: 688.33,
    className: "fishies_after_svg__cls-35",
    rx: 3.44,
    transform: "rotate(26.16 698.407 692.774)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 677.53,
    cy: 700,
    r: 2.61,
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.11,
    cy: 707.16,
    r: 2.61,
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.38 711.87l-1 5.56a1.37 1.37 0 01.38.48l6.89-2.08c0-.32 0-.63.07-.92zM642.31 715.15l2.65 1a3.73 3.73 0 00-.08-2.29z",
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.08 715.58a.47.47 0 010-.82l3.38-1.73a3.65 3.65 0 00-1.44-1.28 3.75 3.75 0 101 6l-2.95-2.13zM646.26 713.14a5.24 5.24 0 01.15 3.52l1.06.38.94-5zM658.07 718.86a3.88 3.88 0 00-1.57-.4c0 2 .18 3.93.18 4a.46.46 0 01-.42.5.47.47 0 01-.24 0 .46.46 0 01-.26-.39c0-.12-.15-2-.19-4a4 4 0 102.5.34z",
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.71 702.9a15.93 15.93 0 107.29 21.32 15.94 15.94 0 00-7.29-21.32zM654 727.14a5.21 5.21 0 011.56-9.84v-.48l-6.74 2a1.76 1.76 0 01-.1.3 1.4 1.4 0 01-1.87.63 1.2 1.2 0 01-.34-.25l-1.23-.89a5.29 5.29 0 11-1.59-8.28 5.15 5.15 0 012.14 2l2.85-1.46.55-1.12a3 3 0 01-1.15-1.66.46.46 0 01.09-.5c.19-.15.51-.1 1.06.17a22.23 22.23 0 012.17 1.34l.51.34c.14.09.5.31.37.58s-1.13.17-1.37.09a2 2 0 00-.73-.09h-.07a.35.35 0 010 .11l-.43.88 6.15 3c.12-.67.27-1.32.36-1.71 0-.16.06-.27.07-.32a.39.39 0 00-.21-.33l-.93-.45a.47.47 0 01-.22-.62.48.48 0 01.63-.22l.91.45a1.26 1.26 0 01.74 1.26s0 .2-.09.44c-.11.5-.33 1.43-.44 2.25a23.62 23.62 0 00-.14 2.56 5.16 5.16 0 012.11.52 5.21 5.21 0 01-4.6 9.36z",
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 641.03,
    cy: 746.27,
    r: 8.66,
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.44 759.72L725.19 731l-39.79-3.55a21.14 21.14 0 00-10.58 1.09c-10.66 4-20 16.82-16.16 27.11s19.41 14.16 30.07 10.18a21 21 0 008.71-6.11zm-22.66-15.26a3.73 3.73 0 112.31-4.84 3.79 3.79 0 01-2.31 4.84z",
    className: "fishies_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.39 721l-2.64 11.58a2.13 2.13 0 001.6 2.54l11.58 2.64a2.12 2.12 0 002.26-3.2l-1.56-1.1a16.82 16.82 0 01-6.87-10.55l-.5-2.57a2.13 2.13 0 00-3.87.66zM682.72 729.12c-.44-2.39 6.07-5.27 6.91-5.64 2.59-1.15 7.27-3.22 9.81-1 1.9 1.68 2.15 5.42.67 7.62-3.48 5.15-16.81 2.25-17.39-.98zM690.29 756.9c.25 2.42 7.3 3.38 8.21 3.51 2.8.38 7.88 1.07 9.69-1.78 1.37-2.15.57-5.81-1.46-7.5-4.73-3.98-16.73 2.5-16.44 5.77z",
    className: "fishies_after_svg__cls-35"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9cab8",
    stroke: "#343a50",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M673.14 943.06c-2.3-12.5 5.07-35.7 2.75-48.19-4.6-24.76-6.4-50.22-13.88-74.27a24.57 24.57 0 01-1-7.29c0-3.14 0-6.6 2.43-9.38a10.86 10.86 0 019.72-3.47c4.12.72 6.71 4.13 10.41 9a35.82 35.82 0 012.78 4.16c2.42 4.32 2.56 6.9 4.65 15.51.2.82 1.36 4.87 3.68 13 1.17 4.1 1.79 6.18 3.12 7.63 3.41 3.73 8.85 3.71 11.11 3.82 7.81.39 43-70.81 43-73.41l13.68-26.75 13.23-26.94 5.51 10 3.19 14.6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_after_svg__Frau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.61 546.75v36L-68 569.58c-5.58-.08-15-2.72-26.08.91-16.31 5.36-28.21 21.11-31.12 40.44L-37 633l140.91 39.21s230.37 17.16 234.05 15.93S583 623.21 583 623.21a71.51 71.51 0 00-6.13-29.44c-3.65-8.12-7.33-16.32-15.93-19.6-6.45-2.47-11.52-3.56-16.43-3.59l-253.15 7.26-.81-31.09",
    className: "fishies_after_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#926652",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M627.12 457.76c1.27-8.11-5.72-14.53-14.71-25.73 0 0-5.68-7.1-27.57-44.12-13.2-22.33-5.85-41.22 0-101.09 1.68-17.16 3-54.94 5.52-130.5 1.62-47.82 2.42-71.73 1.84-79C585.74-2.81 543.11-61.52 526-84.46c-13.18-17.7-62.6-80.58-152.56-117.63-75.34-31-140.73-28.12-183.8-25.73-32 1.77-74.43 4.08-125 23.89-31.44 12.32-118 51.61-172.77 147-6.4 11.27-50.87 91.12-44.07 191.2 2 28.79 9.29 75.61 18.38 117.63C-122 306.37-112.1 330.59-121 367.69c-4.78 20.05-12.11 50.73-36.76 64.34-12.91 7.12-27.37 7.79-31.24 18.38-3.32 9.06 1.81 21 9.19 27.57 7.12 6.3 15.91 6.71 18.38 7.35C-114.85 497.4-77.1 508.58-33.31 517c40.83 7.86 35.17 6.73 74.1 14.27 12.71 2.46 55.66 10.48 115.79 14.7 54.09 3.8 122.13 8.17 207.7-5.51a370 370 0 0038.49-8c14.65-4.06 22.79-6.13 37.75-10.05 14.41-3.78 24.71-6.66 32.2-7.66 0 0 48.15-7.81 128.67-36.76 7.24-2.62 23.95-8.85 25.73-20.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a51",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M-125.25 611.59c24.38 5.29 82.37 1.51 126.52 9.75 98.4 18.37 147.6 27.55 199.43 29.41 59.48 2.14 102.12-3.91 184.72-15.62 86.62-12.29 123.18-17.66 153.46-26.6 2.57-.76 26.5-7.59 34-10.91 10.16-4.52 10.87 32.17 10.87 34.7l-.75 55.87-3.68 99.49-73.08 244.46h-562l-55.87-239.37-14.61-173.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.29 731a987.109 987.109 0 00-8.58 62.86 984.612 984.612 0 00-4.9 74.38 988.4 988.4 0 008.58 160.52h74.74q-3.33-16.18-6.12-33.08a851.57 851.57 0 01-8.58-203.41l-64.15 5.79",
    className: "fishies_after_svg__cls-23"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishiesafter);
export default __webpack_public_path__ + "static/media/fishies.after.e9fd491f.svg";
export { ForwardRef as ReactComponent };